<template>
    <MenuBaseSubmenu :listenerId="listenerId">
        <a :href="getLink('/wordstat')" class="flex xl:hidden">
            <span>{{ $t('lang.menu.guest.wordstat') }}</span>
        </a>
        <a :href="getLink('/clustering')" class="flex xl:hidden">
            <span>{{ $t('lang.menu.guest.clustering') }}</span>
        </a>
        <a :href="getLink('/ai-tracker')" class="flex 2xl:hidden top_menu__item_new">
            <span>{{ $t('lang.menu.guest.ai_tracker') }}</span>
        </a>
        <a :href="getLink('/suggest')">
            <span>{{ $t('lang.menu.guest.suggest') }}</span>
        </a>
        <a :href="getLink('/yandex-direct')">
            <span>{{ $t('lang.menu.guest.yandex_direct') }}</span>
        </a>
        <a :href="getLink('/rsya')">
            <span>{{ $t('lang.menu.guest.rsya') }}</span>
        </a>
        <Divider class="m-0 menu_submenu__divider" />
        <a :href="getLink('/tools')">
            <span>{{ $t('lang.menu.guest.tools') }}</span>
        </a>
    </MenuBaseSubmenu>
</template>

<script>
import {Listeners} from "../../../constants/listeners";
import MenuBaseSubmenu from "./BaseSubmenu.vue";
import Divider from "primevue/divider";

export default {
    name: "MenuSubmenuTopGuestMore",
    data() {
        return {
            listenerId: Listeners.TOP_MENU_TOP_GUEST_MORE_HOVER,
        };
    },
    methods: {
        getLink(url) {
            return sprintf('/%s%s', window.locale, url);
        },
    },
    components: {
        MenuBaseSubmenu,
        Divider,
    },
}
</script>

<style scoped>
.menu_submenu__divider:before {
    border-top: 1px solid #6C757D !important;
}
</style>
